module.exports = __webpack_public_path__ + "static/media/ktp.5afa2dbd.png";